import React from 'react';

import Kit from '../utility/Kit.jsx';
import * as ListContainer from '../common/ListContainer.jsx';
import Name from '../utility/Name.jsx';
import { Component as PaymentCreditCellComponent } from './PaymentCreditCell.jsx';
import TypeConfig from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function _Header(props) {
    if (props.config && props.config.config && props.config.config.Header && !Utilities.isHTMLContentEmpty(props.config.config.Header.design)) {
        let styleHeader;
        if (props.config.config.Header.paddingBottom && props.config.config.Header.paddingBottom.value && props.config.config.Header.paddingBottom.value.length > 0) {
            styleHeader = { paddingBottom: `${props.config.config.Header.paddingBottom.value}${props.config.config.Header.paddingBottom.unit}` };
        }
        const design = Kit.updateDesign(props.config.config.Header.design, props.kit);
        let content = (
            <tr>
                <td colSpan={props.config.config.Block && props.config.config.Block.columns}>
                    <div dangerouslySetInnerHTML={{ __html: design }} style={styleHeader} />
                </td>
            </tr>
        )
        if (!props.builder) {
            content = (
                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                    <tbody>
                        {content}
                    </tbody>
                </table>
            )
        }
        return content;
    }
    return null;
}
const _TypeConfigHeader = {
    panel: {
        header: (defaultText) => {
            const group = 'header';
            return {
                group,
                label: 'Header',
                options: [
                    {
                        display: 'Design',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral-short',
                        value: Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: defaultText })
                    },
                    {
                        display: 'Line Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'paddingBottom',
                        options: TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        value: { "unit": "px", "value": "10" }
                    }
                ]
            }
        }
    }
}

// #region CREDITS

function CreditsTable(props) {
    const data = props.data || {};
    if (!props.builder && (!data.IssuedCredits || !data.IssuedCredits.length)) {
        return null;
    }
    return <ListContainer.Component cellComponent={PaymentCreditCellComponent} header={<_Header {...props} />} records={data.IssuedCredits} {...props} />
}

const CreditsTypeConfig = {
    panel: {
        block: () => ListContainer.TypeConfig.panel.block(Name.Content.CreditLineItem, { itemSeparatorSize: { "unit": "px", "value": "" }, itemSpacing: { "unit": "px", "value": "10" } }),
        header: () => _TypeConfigHeader.panel.header('Credits'),
        style: ListContainer.TypeConfig.panel.style
    }
}

// #endregion CREDITS

// #region PAYMENTS

function PaymentsTable(props) {
    const data = props.data || {};
    if (!props.builder && (!data.Payments || !data.Payments.length)) {
        return null;
    }
    let records;
    if (props.config && props.config.config) {
        if (props.config.config.Block && props.config.config.Block.includeRefunds) {
            records = [];
            data.Payments.forEach(payment => {
                records.push(payment);
                if (payment.Refunds) {
                    payment.Refunds.forEach(refund => records.push(refund));
                }
            })
        } else {
            records = data.Payments;
        }
    }
    return <ListContainer.Component cellComponent={PaymentCreditCellComponent} header={<_Header {...props} />} records={records} {...props} />
}

const PaymentsTypeConfig = {
    panel: {
        block: () => {
            const blockConfig = ListContainer.TypeConfig.panel.block(Name.Content.PaymentLineItem, { itemSeparatorSize: { "unit": "px", "value": "" }, itemSpacing: { "unit": "px", "value": "10" } })
            blockConfig.options.push({
                display: 'Include refunds',
                fullWidth: true,
                group: blockConfig.group,
                name: 'includeRefunds',
                type: 'checkbox',
                value: true
            });
            return blockConfig;
        },
        header: () => _TypeConfigHeader.panel.header('Payments'),
        style: ListContainer.TypeConfig.panel.style
    }
}

// #endregion PAYMENTS

export {
    CreditsTable,
    CreditsTypeConfig,
    PaymentsTable,
    PaymentsTypeConfig
}